<template>
  <div id="home-page">

    <!-- Home Hero Section -->
    <section id="home">
      <div class="home-container text-center">
        <h1>IBM i Development Services</h1>
        <h2>From application integration to application modernization and everything in between.</h2>

        <a href="#about" class="btn-get-started" @click.prevent="scrollToSection('#about')">
          Find Out More
        </a>
      </div>
    </section>

    <!-- About Section -->
    <AboutSection />

    <!-- Call to Action Section -->
    <CallToAction />

    <!-- Services Section -->
    <ServicesSection />

    <!-- Contact Section -->
    <ContactSection />

  </div>
</template>

<script>
import AboutSection from '@/components/AboutSection.vue';
import CallToAction from '@/components/CallToAction.vue';
import ServicesSection from '@/components/ServicesSection.vue';
import ContactSection from '@/components/ContactSection.vue';

export default {
  name: 'HomeView',
  components: {
    AboutSection,
    CallToAction,
    ServicesSection,
    ContactSection
  },
  methods: {
    scrollToSection(hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
};
</script>
